export default __webpack_public_path__ + "static/media/tutsplus.8a70d8d4.svg";